export enum ROUTES {
  Logs = '/logs',
  Blueprints = '/blueprints',
  Docs = '/docs',
  AnsibleRuns = '/ansibleruns',
  HealthStatus = '/healthstatus',
  BlueprintVersions = '/blueprints/:id/versions',
  PlatformDetails = '/platforms/:platformCode/environments/:environmentCode/products',
}
